<script lang="ts">
    import Component, { mixins } from 'vue-class-component';
    import PageBase from "@common/PageBase";
    import VuePageQueries from "@Organizations/Users/Domain/queries-vue-component";
    import VuePageCommands from "@Organizations/Users/Domain/commands-vue-component";
    import "@common/Components/ValidationError.vue";

    enum Status {
        Initial,
        Invoking,
        Succeed,
        Invalid,
        Failed
    }

    @Component
    export default class SsoPage extends mixins(PageBase, VuePageQueries, VuePageCommands) {
        email = '';
        status: Status = Status.Initial;

        get statusInitial() { return this.status == Status.Initial }
        get statusInvoking() { return this.status == Status.Invoking }
        get statusSucceed() { return this.status == Status.Succeed }
        get statusInvalid() { return this.status == Status.Invalid }
        get statusFailed() { return this.status == Status.Failed }

        mounted() {
            this.setTitle('Sign in with SSO to TransparentChoice');
        }

        handleRequestSsoUrlCommandV1() {
            this.status = Status.Invoking;
            this.$clearValidationErrors();
            this.invokeRequestSsoUrlCommandV1(this.email);
        }

        succeedRequestSsoUrlCommandV1(status) {
            this.status = Status.Succeed;
        }

        invalidRequestSsoUrlCommandV1(status) {
            this.$pushValidationErrors(status.ValidationErrors);
            this.status = Status.Initial;
        }

        failedRequestSsoUrlCommandV1(status) {
            this.status = Status.Failed;
        }

        handleTryAgain() {
            this.status = Status.Initial;
        }
    }
</script>

<template>
    <div>
        <div style="min-width: 400px; width: 40vw; margin: auto; margin-top: 100px;" class="border-box">
            <h3 class="fg-color-blue">Sign-in with SSO</h3>
            <br />

            <div v-show="statusInitial || statusInvoking">
                <div class="form-group">
                    <label>Email:</label>
                    <input v-model="email" type="email" class="form-control" placeholder="Email address">
                    <ValidationError context="Email" :errors="validationErrors"></ValidationError>
                </div>

                <button v-show="statusInitial" @click="handleRequestSsoUrlCommandV1" class="btn btn-lg btn-primary btn-block">Sign-in</button>
                <button v-show="statusInvoking" class="btn btn-lg btn-primary btn-block" disabled>Signing-in...</button>
                <br />

                <!--<span>
        <span>Don't have an account?</span>
        <a href="/#/organizations/users/requestaccount">Request access</a>
    </span>-->
            </div>

            <div v-show="statusSucceed">
                <p>
                    To complete sign-in please check your mailbox. We have sent you link to sign-in to TransparentChoice via your organizational account.
                    If you didn't receive anything please ensure that your account is valid and your organization has enabled SSO or just try again.
                    <button @click="handleTryAgain" class="btn btn-link float-right">Try again</button>
                </p>
            </div>

            <hr /><br />
            <a href="/#/organizations/users/signin" class="btn btn-secondary btn-lg btn-block">Sign-in with password</a>
        </div>
    </div>
</template>